import { assocIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertScreenItem($input: ScreenItemInput) {
    upsertScreenItem(input: $input) {
      id
      name
    }
  }
`

const cleanRequest = (widget, screen, index) => ({
  id: widget.id,
  ...assocIf(!!widget.data, 'data', JSON.stringify(widget.data)),
  ...assocIf(!!widget.size, 'size', JSON.stringify(widget.size)),
  ...assocIf(!!widget.position, 'position', JSON.stringify(widget.position))
})

export const useSaveWidget = () => {
  const [request, state] = useMutation(MUTATION, { client: generalClient })

  const handleRequest = widget => {
    const input = cleanRequest(widget)

    return request({ variables: { input } }).then(resp => {})
  }

  return [handleRequest, state]
}
